import { render, staticRenderFns } from "./YearTabFilter.vue?vue&type=template&id=1d5c9a02&"
import script from "./YearTabFilter.vue?vue&type=script&lang=js&"
export * from "./YearTabFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports